import { Trans } from 'react-i18next';

import { EmptyState as SharedEmptyState } from 'shared/components/EmptyState';

import type { FC } from 'react';
import type { EmptyStateProps as SharedEmptyStateProps } from 'shared/components/EmptyState';

type EmptyStateProps = Partial<
  Pick<SharedEmptyStateProps, 'header' | 'description'>
>;

export const EmptyState: FC<EmptyStateProps> = ({
  header = <Trans i18nKey="GSP.components.tile.emptyState.header" />,
  description = <Trans i18nKey="GSP.components.tile.emptyState.description" />,
}) => (
  <SharedEmptyState
    header={header}
    description={description}
    imageProps={{ maxWidth: 160 }}
  />
);
